module.exports = __webpack_public_path__ + "public/Icons/1Dashboard.svg?04a780a5";